<script>
import Button from "@/components/atoms/button";

export default {
  name: "PaymentMethodRegisterCardCora",
  components: {
    Button
  },

  props: {
    isEligibleDefis: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["addCarte"]
};
</script>

<template>
  <div class="u-mb-md">
    <p class="u-font-700 u-font-15 u-mb-xs">
      Bénéficiez de tous vos avantages en enregistrant votre carte de paiement cora Cpay Mastercard
    </p>
    <Button
      link
      @click="$emit('addCarte')"
    >
      Enregistrer ma Carte
    </Button>
  </div>
</template>

<style lang="scss" scoped>
</style>
